import { render, staticRenderFns } from "./IndustryForm.vue?vue&type=template&id=695479ce&scoped=true"
import script from "./IndustryForm.vue?vue&type=script&lang=js"
export * from "./IndustryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695479ce",
  null
  
)

export default component.exports